
import { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  capabilities: PropTypes.arrayOf(PropTypes.element),
};

function createElementTree(elements, children) {
  if (elements.length === 0) {
    return children;
  }
  const instance = elements.pop();
  return cloneElement(instance, {
    children: createElementTree(elements, children),
  });
}

/**
 * The `CapabilityProvider` is a technical component that wraps React components around its children.
 */
class CapabilityProvider extends Component {
  render(argChildren) {
    const children = argChildren || this.props.children;
    const { capabilities } = this.props;
    const reversedCapabilities = capabilities.slice().reverse();
    return createElementTree(reversedCapabilities, children);
  }

  static propTypes = propTypes;

  static defaultProps = {
    capabilities: [],
  };
}

export { CapabilityProvider };
export default CapabilityProvider;
